<template>
  <div v-if="getSelectedEvaluation">
    <b-row>
      <b-col class="mt-2">
        <div class="cardContainer">
          <h4>
            {{ getSelectedEvaluation.evaluation_administrator_model_name }}
          </h4>

          <div
            style="
              display: inline-flex;
              width: 100%;
              font-size: 17px;
              font-weight: bold;
            "
          >
            <div
              class="mediumTitle"
              style="width: calc(100% - 300px); font-size: 1rem"
            >
              {{$t("label_evaluation_evaluationMatrix_evaluationModel_row_title")}}
            </div>
            <div
              class="mediumTitle"
              style="font-size: 1rem"
            >
              {{ $t("label_evaluation_evaluationMatrix_progress_row_title") }}
            </div>
            <div
              class="mediumTitle"
              style="font-size: 1rem"
            >
              {{ $t("label_evaluation_status") }}
            </div>
            <div
              class="mediumTitle"
              style="line-height: normal; font-size: 1rem"
            >
              {{ $t("label_evaluation_lastUpdated") }}
            </div>
          </div>
          <evaluation-evaluate-tree-list
            v-if="model"
            :path="[]"
            :draggable="false"
            :model="model"
            :evaluation-id="getSelectedEvaluation.id"
            @updatePath="updatePath"
          />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import EvaluationEvaluateTreeList from "./EvaluationEvaluateTreeList";
import { mapGetters } from "vuex";
import { cloneDeep } from "lodash";

export default {
  name: "EvaluationAuditTab",
  components: { EvaluationEvaluateTreeList },
  data: function () {
    return {
      model: null,
    };
  },
  watch: {
    getSelectedEvaluation: function () {
      if (this.getSelectedEvaluation) {
        this.model = cloneDeep(this.getSelectedEvaluation.evaluation);
      }
    },
  },
  mounted() {
    if (
      this.model === null &&
      this.getSelectedEvaluation &&
      this.getSelectedEvaluation.evaluation
    ) {
      this.model = cloneDeep(this.getSelectedEvaluation.evaluation);
    }
  },
  methods: {
    updatePath(path) {
      path.reverse();
      this.path = path;
      this.$store.dispatch("REPORT_BUTTON_SET", false);
    },
  },
  computed: {
    ...mapGetters(["getSelectedEvaluation", "getSavingStatus"]),
  },
};
</script>


